import React from "react";
import { TextComponent } from "./TextComponent";
import { Row } from "./Row";
import { urlBySinthiaFlores } from "../constants/utils";

interface EstilistasSectionProps {
	titulo: string;
	backgroundImage: string;
}

export const StartSection: React.FC<EstilistasSectionProps> = ({ titulo, backgroundImage }) => (
	<div>
		<TextComponent
			variant="h6"
			className="w-full text-center py-2 text-darkPurple"
		>
			Megabodas -{" "}
			<a
				href={urlBySinthiaFlores}
				target="_blank"
				rel="noreferrer"
				className="underline text-secondaryPurple"
			>
				by Sinthia Flores
			</a>
		</TextComponent>
		<Row
			className="relative py-16 sm:py-28 bg-cover bg-center w-full px-4"
			style={{ backgroundImage: `url('${backgroundImage}')` }}
			crossAxisAlignment="center"
			mainAxisAlignment="center"
			responsiveCol
		>
			<div className="absolute w-full h-full bg-black/70" />
			<TextComponent
				variant="big"
				className="uppercase font-bold text-lightPurple text-center z-10"
			>
				{titulo}
			</TextComponent>
		</Row>
	</div>
);
